export enum WidgetTheme {
  LIGHT = 'light',
  DARK = 'dark',
  BLUE = 'blue',
  GOLD = 'gold',
}
